/**
 * Builds the one error outcome every workflow run site reports.
 *
 * Consumers: `ArWorkflowMenu`, `ArTableControls`, `useFormWorkflowRun`,
 * `RelationshipTree` and `WorkflowParameterContent`. Three of them interpolated
 * `err.message` themselves, which put the callable's flattened `INTERNAL` on
 * screen; all five now word a failure identically (SYD-2445).
 *
 * `text` is the only string a caller displays. `code` and `details` are for the
 * branches that act on the failure — the placed-but-unsynced-order modal, and the
 * parameter sidebar's banner description.
 */

import formatWorkflowErrorMessage from './formatWorkflowErrorMessage';
import { readCallableError } from './readCallableError';
import type { WorkflowRunOutcome } from './workflowRunOutcome.types';

export const workflowRunErrorOutcome = (
  error: unknown,
  workflowLabel: string | undefined,
): Extract<WorkflowRunOutcome, { status: 'error' }> => {
  const { code, details } = readCallableError(error);

  return {
    status: 'error',
    text: formatWorkflowErrorMessage(error, workflowLabel),
    ...(code ? { code } : {}),
    ...(details ? { details } : {}),
  };
};
